import { render, staticRenderFns } from "./DocumentAPIWebscript.vue?vue&type=template&id=5b3ec34c&scoped=true&"
import script from "./DocumentAPIWebscript.vue?vue&type=script&lang=js&"
export * from "./DocumentAPIWebscript.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAPIWebscript.vue?vue&type=style&index=0&id=5b3ec34c&prod&scoped=true&lang=css&"
import style1 from "./DocumentAPIWebscript.vue?vue&type=style&index=1&id=5b3ec34c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ec34c",
  null
  
)

export default component.exports